import { useTranslation } from "react-i18next";
import { useDownloadFile } from "components/shared/download-file/use-download-file";
import { useToast } from "shared/toast/hooks/use-toast";
import { makeFullPath } from "api/path";

interface Args {
  projectId: string;
  agreementId: string;
  agreementInternalNumber?: number;
}

export function usePrintExtraWorkAgreement({ projectId, agreementId, agreementInternalNumber }: Args) {
  const { t } = useTranslation();
  const toast = useToast();
  const downloadFile = useDownloadFile();

  const printAgreement = async () => {
    if (!projectId || !agreementId) {
      return;
    }
    try {
      const fileName = `Ekstraarbejdsaftale-${agreementInternalNumber ?? agreementId}.pdf`;
      const url = makeFullPath(`/api/projects/${projectId}/extraworkagreements/${agreementId}/pdf`);
      await downloadFile(url, fileName);
    } catch {
      toast.error(t("dashboard.extraWorkAgreements.create.pdfDownloadError"));
    }
  };

  return printAgreement;
}
